import { Component } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MVMStandardTabModel } from '../../shared/components/mvm-tab/models/mvm-standard-tab.model';
import { NotificationTabModule } from './notification-tab-module';
import { SecurityTransactionType } from '../../auth/models/security-transaction-type.enum';

@Component({
    selector: 'notification-center-modal',
    templateUrl: './notification-center.html',
})
export class NotificationCenterWindow extends BaseComponent {
    public tabData: any;
    public modules = [NotificationTabModule];
    public securityTransactionTypeEnum = SecurityTransactionType;

    constructor() {
        super();
        this.tabData = this.buildTable();
    }

    ngOnInit() { }

    buildTable() {
        const t1 = new MVMStandardTabModel();
        t1.title = 'My Notifications';
        t1.showType = 'my-notifications';
        t1.order = 0;

        if (this.auth.hasSecurityTransactionClaim(this.securityTransactionTypeEnum.CreateNotification)) {
            const t2 = new MVMStandardTabModel();
            t2.title = 'Create Notification';
            t2.showType = 'create-notification';
            t2.order = 1;
            return [t1, t2];
        }

        return [t1];
    }
}
